// Utility for checkout only
export function checkoutScrollToTop()  {
  const element = document.querySelector('.kb-checkout-content__wrapper');
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
}